import { useState } from 'react';
import { usePageKeyboard } from '../../keyboard/state/use-page-keyboard';

export function useIsShiftPressed(): boolean {
    let [isShiftPressed, setIsShiftPressed] = useState(false);

    usePageKeyboard({
        onKeyDown: (event) => {
            if (event.key === 'Shift') {
                setIsShiftPressed(true);
            }
        },
        onKeyUp: (event) => {
            if (event.key === 'Shift') {
                setIsShiftPressed(false);
            }
        },
        onPageBlur: () => setIsShiftPressed(false)
    });

    return isShiftPressed;
}
